import {Component, CUSTOM_ELEMENTS_SCHEMA, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ErrorInfo} from '../../shared/model/error-info';
import {ErrorHandlingService} from '../../shared/service/error-handling/error-handling.service';
import {map} from 'rxjs/operators';
import {TranslatePipe} from '@ngx-translate/core';
import {AsyncPipe} from '@angular/common';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {ErrorBoxComponent} from '../error-box/error-box.component';
import {MatCard} from '@angular/material/card';
import {VERSION} from '../../../../environments/version';

import '@datev/dacks/content';
import '@datev/dacks/content-header';
import { FooterSpacing } from "../footer/footer-spacing";

export interface AttributionReport {
  title: string;
  header: string;
  // detail: object;
  detail: {[library: string]: AttributionReportLibraryDetails[]};
  appendix: [
    {
      licenseName: string;
      licenseText: string;
    }
  ];
}

export interface AttributionReportLibraryDetails {
  itemNumber: number;
  licenses: [
    {
      license: string;
      licenseReference: string;
      licenseText: string;
    }
  ];
  copyrights: [
    {
      copyright: string,
      copyrightReference: string,
      author: string
    }
  ];
  notices: {
      noticeText: string;
      noticeReference: string;
  };
}

@Component({
    selector: 'myupdates-terms-of-use',
    templateUrl: './terms-of-use.component.html',
    styleUrls: ['./terms-of-use.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [MatCard, ErrorBoxComponent, MatProgressSpinner, AsyncPipe, TranslatePipe, FooterSpacing]
})
export class TermsOfUseComponent implements OnInit {

  feVersion = VERSION.version;

  attributionReport$?: Observable<AttributionReport>;
  errorInfo$: Observable<ErrorInfo>;

  constructor(private readonly httpClient: HttpClient,
              private readonly errorHandlingService: ErrorHandlingService) {
    this.errorInfo$ = this.errorHandlingService.errorStream$;
  }

  ngOnInit(): void {
    this.attributionReport$ = this.errorHandlingService.bindErrorHandling(
      this.httpClient.get('./assets/license/NOTICE.json', { responseType: 'text', observe: 'response'})
        .pipe(map(rep => JSON.parse(rep.body as string) as AttributionReport))
    );
  }

  getLibraries(report: AttributionReport): string[] {
    return report?.detail ? Object.keys(report.detail) : [];
  }

  getLibraryDetails(report: AttributionReport | null, libraryName: string): AttributionReportLibraryDetails[] {
    const libaryDetails = report?.detail[libraryName];
    return libaryDetails ?? [];
  }

}
